var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrack4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 54,
    viewBox: "0 0 130 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4254 21.1649L7.45465 21.0361L7.47249 20.9053L7.83641 18.2366C8.71316 11.8071 16.1637 8.67308 21.3727 12.5426L21.6925 12.7802C22.969 13.7285 24.3967 14.4541 25.9151 14.9265L28.4917 15.7281C36.8766 18.3368 44.7814 11.9814 45.0149 3.99909L64.8987 6.67006C67.3576 7.00036 68.678 9.73699 67.4062 11.8672L66.541 13.3164C61.5544 21.6689 71.4112 30.9557 79.4522 25.481C80.1811 24.9847 80.8339 24.385 81.3899 23.7006L82.018 22.9276C84.4932 19.8812 88.5363 18.5876 92.3202 19.6314L93.0998 19.8465C97.4511 21.0468 102.1 20.4806 106.036 18.2709L107.848 17.2537C115.902 12.7321 125.91 18.206 126.447 27.4269L126.809 33.6488C127.207 40.4775 120.07 45.1809 113.952 42.1218C111.02 40.656 107.687 40.1981 104.468 40.8192L56.4167 50.0923C53.6085 50.6342 50.7116 50.4992 47.9659 49.6984L34.4932 45.7688C30.2675 44.5364 25.7842 44.4897 21.5338 45.6341L3.58596 50.4662L4.87467 33.2833C4.9414 32.3937 5.07416 31.5103 5.27187 30.6404L7.4254 21.1649Z",
    stroke: "currentColor",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack4);
export default __webpack_public_path__ + "static/media/track4.ed2f5075.svg";
export { ForwardRef as ReactComponent };